module.exports = __webpack_public_path__ + "static/img/042_7.ba8571b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_7.jpg
// module id = EfFB
// module chunks = 1